export default "__VITE_ASSET__404a7300__"